export default {
    text: {
        title: 'Tekst',
        addText: 'Ny tekst',
        fontFamily: 'Skrifttypefamilie',
        fontSize: 'Font size',
        textAlignment: 'Tekstjustering',
        fontColor: 'Skriftfarve',
        lineSpacing: 'Linjeafstand',
        arialSerif: 'Arial (sans-serif)',
        verdanaSansSerif: 'Verdana (grotesk)',
        tahomaSansSerif: 'Tahoma (serifløs)',
        trebuchetMSSansSerif: 'Trebuchet MS (sans-serif) ',
        timesNewRomanSerif: 'Gange Roman (serif)',
        georgiaSerif: 'Georgia (serif)',
        garamondSerif: ' Garamond (serif)',
        courierNewMonospace: ' Courier New (monotype)',
        brushScriptMTCursive: 'Brush Script MT (kursiv)',
        backgroundColor: 'Baggrundsfarve',
    },
};
